import object from 'helpers/object'


export const initialState = {
  isFetching: false,
  classes: [],

  dates: [],
  schools: [],
  categories: [],
}

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)


export const setClasses = (state, payload) => (
  object.setIn(state, [ 'classes' ], payload)
)



export const setDates = (state, payload) => (
  object.setIn(state, [ 'dates' ], payload)
)

export const setSchools = (state, payload) => (
  object.setIn(state, [ 'schools' ], payload)
)

export const setCategories = (state, payload) => (
  object.setIn(state, [ 'categories' ], payload)
)
